import React from "react";

import { AlertCircleIcon, AlertTriangleIcon, CheckCircleIcon, InfoIcon } from "../../icons";
import type { IconType } from "react-icons";

export enum AlertKind {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  INFO = "INFO",
  WARNING = "WARNING",
}

type AlertProps = {
  kind?: AlertKind;
  children?: React.ReactNode;
};

const Alert = ({ kind = AlertKind.ERROR, children }: AlertProps) => {
  let Icon: IconType;
  let iconColor: string;
  let backgroundColor: string;
  let borderClass = "";
  let textColor: string;

  switch (kind) {
    case AlertKind.INFO:
      Icon = InfoIcon;
      iconColor = "text-gray-900";
      backgroundColor = "bg-gray-50";
      borderClass = "border border-gray-200";
      textColor = "text-gray-900";
      break;
    case AlertKind.SUCCESS:
      Icon = CheckCircleIcon;
      iconColor = "text-emerald-600";
      backgroundColor = "bg-emerald-50";
      textColor = "text-emerald-700";
      break;
    case AlertKind.WARNING:
      Icon = AlertTriangleIcon;
      iconColor = "text-amber-600";
      backgroundColor = "bg-amber-50";
      borderClass = "border border-amber-200";
      textColor = "text-amber-800";
      break;
    default: // Errors
      Icon = AlertCircleIcon;
      iconColor = "text-red-700";
      backgroundColor = "bg-red-50";
      textColor = "text-red-700";
      break;
  }

  return (
    <div className={`rounded-md ${borderClass} ${backgroundColor} px-4 py-3`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <Icon className={`h-5 w-5 ${iconColor}`} aria-hidden="true" />
        </div>
        <div className="ml-3">
          <h3 className={`text-sm font-medium ${textColor}`}>{children}</h3>
        </div>
      </div>
    </div>
  );
};

export default Alert;
